/**
 * Page manager open state.
 *
 * Was local to PagesPills (its "..." button), and PagesPills renders nothing
 * for a one-page project - so the manager, which is also where "+ Add page"
 * lives, could not be reached at all until a project already had two pages,
 * and the only other way to add one was the edit-mode canvas right-click menu.
 * Lifted here (2026-09-30) so Navigate's Pages card opens it for any project,
 * and App mounts it where every other shell modal mounts.
 */

import { createSignal } from 'solid-js';

const [open, setOpen] = createSignal(false);

export const pageManagerOpen = open;
export function openPageManager(): void { setOpen(true); }
export function closePageManager(): void { setOpen(false); }
